// Module
var code = "<mn-consultation-summary ng-model=\"::consultation\" visit=\"::vm.visit\"\r\n                         ng-repeat=\"consultation in vm.consultations track by consultation.id\"></mn-consultation-summary>";
// Exports
module.exports = code;